// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__A5vWy","fullWidth":"styles_fullWidth__Mpukd","heading":"styles_heading__VYBiy","subheading":"styles_subheading__k0t88"};